<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-row>
      <v-col>
        <v-text-field
          hide-details="auto"
          label="* Add a short task description"
          dense
          outlined
          v-model="formData.title"
          :rules="[$formRules.required]"
        >
          <v-icon slot="prepend" color="#eaeaea">
            mdi-checkbox-blank-outline
          </v-icon>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-select
          label="Assigned"
          hide-details="auto"
          outlined
          dense
          :items="items"
          item-text="name"
          item-value="id"
          v-model="formData.assigned_to"
        ></v-select>
      </v-col>

      <v-col cols="3">
        <v-checkbox
          v-model="formData.urgent"
          hide-details="auto"
          label="Urgent"
          class="pt-0 mt-2"
        ></v-checkbox>
      </v-col>

      <v-col cols="5" align="end">
        <v-btn
          color="secondary"
          class="mr-2"
          depressed
          :disabled="!valid"
          :loading="loading"
          type="submit"
        >
          Save
        </v-btn>

        <v-btn color="secondary" text @click="cancel">Cancel</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TaskCreateEditForm',
  props: {
    taskList: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    formData: {}
  }),
  computed: {
    ...mapGetters('projects', ['project']),

    items() {
      return [
        { header: 'Clients' },
        ...this.project.clients,
        { header: 'Managers' },
        ...this.project.managers,
        { header: 'Workers' },
        ...this.project.workers
      ]
    }
  },
  methods: {
    ...mapActions('tasks', ['storeTask']),
    setFormDefaults() {
      this.formData = {
        title: '',
        assigned_to: null,
        urgent: false
      }
    },
    submit() {
      this.loading = true
      this.storeTask({
        task_list_id: this.taskList.id,
        ...this.formData
      }).finally(() => {
        this.loading = false

        this.cancel()
      })
    },
    cancel() {
      this.$refs.form.reset()

      this.setFormDefaults()

      this.$emit('cancel')
    }
  },
  created() {
    this.setFormDefaults()
  }
}
</script>
